import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {FORMANTS_WIDTH, FORMANTS_HEIGHT} from './constants.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK = 400;

const Formant = memo(({formant, width, height, setDraggingFormant, isSelected, frequency, q, gain, enabled}) => { 

    let bandRef = useRef(undefined);
    let groupRef = useRef(undefined);
    let bandRef2 = useRef(undefined);
    let lastClick = useRef(0);

    let className = "formant";
    if (enabled) {
        className += " enabled";
    }

    if (isSelected) {
        className += " selected";
    }

    const onMouseDown = useCallback(() => {
        let now = new Date().getTime();
        if (now - lastClick.current <= DOUBLE_CLICK) {
            let enabled = !formant.enabledParameter.get();
            formant.enabledParameter.set(enabled);
        }
        lastClick.current = now;
        if (formant.enabledParameter.get()) {
            setDraggingFormant(formant);
        }
    }, [formant, setDraggingFormant]);

    const onMouseUp = useCallback(() => {
        setDraggingFormant(undefined);
    }, [setDraggingFormant]);

    let bandwidth = frequency / (0.5 * q);
    let _bandwidthPixels= (Math.sqrt(bandwidth/ 20000) * width) / 2;
    let bandwidthPixels= 100;
    let scale = _bandwidthPixels/bandwidthPixels;

    let x1 = bandwidthPixels-bandwidthPixels;
    let y1 = height;
    let x2 = bandwidthPixels - bandwidthPixels / 2.0;
    let y2 = -10;
    let x3 = bandwidthPixels + bandwidthPixels / 2.0;
    let y3 = -10;
    let x4 = 2*bandwidthPixels;
    let y4 = height;
    let curve = `M ${x1} ${y1} C ${x2} ${y2}, ${x3} ${y3}, ${x4} ${y4}`

    useEffect(() => {
        let x = Math.sqrt(frequency / 20000) * width;
        let y = height - (gain / 4.0) * height;

        if (groupRef.current) {
            let _x = x - 8;
            let _y = y - 8;
            groupRef.current.style["transform"] = `translate(${_x}px, ${_y}px)`;
        }
        if (bandRef.current) {
            let _x = x-bandwidthPixels;
            bandRef.current.style["transform"] = `translate(${_x}px, ${y}px) scale(${scale}, 1)`;
        }
    }, [frequency, gain, scale, _bandwidthPixels]);

    return [
        <div
          key={1}
          className={isSelected ? "band-wrap selected" : "band-wrap"}
          ref={bandRef}>
          <Bandwidth curve={curve} isSelected={isSelected}/>
        </div>,
        <div
          className={isSelected ? "circle-wrap selected" : "circle-wrap"}
          key={2}
          ref={groupRef}>
          <Elem
            className={className} isSelected={isSelected}
            formant={formant}
            onMouseDown={onMouseDown} onMouseUp={onMouseUp}/>
        </div>
    ];
});

const Bandwidth = memo(({isSelected, curve, bandRef}) => {
    return (
        <svg className="bandwidth-svg" height={100} width={200} ref={bandRef}>  
          <path
            d={curve} className={isSelected ? "bandwidth selected" : "bandwidth"}/>
        </svg>);
});

const Elem = memo(({onMouseDown, onMouseUp, formant, curve, isSelected, className}) => {
    return (
        <svg className="circle-svg" width={16} height={16}>
          <circle
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            className={className}
            cx={8}
            cy={8}
            r={8}
            strokeWidth={1}
            key={2}
          />
          <text
            key={3}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            x={-3+8} y={4+8}>
            {formant.number + 1}
          </text>
        </svg>);
});

const mapStateToProps = (state, props) => {
  return {
      enabled: props.formant.enabledParameter.get(),
      frequency: props.formant.formantFrequencyParameter.get(true),
      q: props.formant.formantQParameter.get(true),
      gain: props.formant.formantGainParameter.get(true),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Formant);
